import { layoutTargets } from './layoutTargets';
import { preview } from './preview';

export const AllTargets = {
  layoutTargets,
  preview,
};
